module.exports = __webpack_public_path__ + "3dff25489dda6c5647cef3ad407a0a0b.pdf";